import React, { useState, useEffect } from 'react';
import Card from '../shared/Card';
import './SubmittedView.css';

const INTAKE_MESSAGES = [
  'Assessing the quality of your credentials...',
  'Checking the quality of your data...',
];

const PUBLIC_MESSAGES = [
  'Cross-checking against public sources...',
  'Verifying your data is truly novel...',
  'Seeing if your beliefs are contrarian...',
];

const SubmittedView = ({ kernelId, status, kernel }) => {
  const [messageIndex, setMessageIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  const getMessages = () => {
    switch (status) {
      case 'intake_processing':
        return INTAKE_MESSAGES;
      case 'public_processing':
        return PUBLIC_MESSAGES;
      case 'public_complete':
        return ['Processing complete'];
      case 'error':
        return ['An error occurred during processing'];
      default:
        return ['Processing...'];
    }
  };

  const messages = getMessages();

  // Check if we have intake data to show (during public_processing or later)
  const showIntakeData = kernel && (
    status === 'public_processing' || 
    status === 'public_complete'
  ) && (kernel.intake_agent_thoughts || kernel.search_question);

  // Reset message index when status changes
  useEffect(() => {
    setMessageIndex(0);
    setIsVisible(true);
  }, [status]);

  // Rotate messages every 6 seconds with fade transition
  useEffect(() => {
    if (messages.length <= 1) return;

    const interval = setInterval(() => {
      // Fade out
      setIsVisible(false);

      // After fade out, change message and fade in
      setTimeout(() => {
        setMessageIndex((prev) => (prev + 1) % messages.length);
        setIsVisible(true);
      }, 300);
    }, 6000);

    return () => clearInterval(interval);
  }, [messages.length, status]);

  return (
    <div className="submitted-view">
      <Card title="Belief Submitted">
        <div className="submitted-view__content">
          <div className="submitted-view__id">
            <span className="submitted-view__id-label">Kernel ID:</span>
            <span className="submitted-view__id-value">{kernelId}</span>
          </div>

          <div className="submitted-view__progress">
            <p className={`submitted-view__progress-text ${isVisible ? 'visible' : 'hidden'}`}>
              {messages[messageIndex]}
            </p>
            <div className="submitted-view__progress-bar">
              <div className="submitted-view__progress-fill" />
            </div>
          </div>
        </div>
      </Card>

      {showIntakeData && (
        <div className="submitted-view__demo-box">
          <div className="submitted-view__demo-header">
            <span className="submitted-view__demo-label">For Demo Purposes Only</span>
          </div>
          <div className="submitted-view__demo-content">
            {kernel.intake_agent_thoughts && (
              <div className="submitted-view__demo-section">
                <h4 className="submitted-view__demo-title">Intake Agent Assessment:</h4>
                <p className="submitted-view__demo-text">{kernel.intake_agent_thoughts}</p>
              </div>
            )}
            {kernel.search_question && (
              <div className="submitted-view__demo-section">
                <h4 className="submitted-view__demo-title">Generated Search Question:</h4>
                <p className="submitted-view__demo-text">{kernel.search_question}</p>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default SubmittedView;
